export const STRIPE_PRICES = {
  starter: {
    monthly: 'price_1QfBlKHK89bZG7Iq8c0726db', // 19€/mois
    yearly: 'price_1QfIYxHK89bZG7Iq3iEpCWUu'   // 190€/an
  },
  professional: {
    monthly: 'price_1QfBn6HK89bZG7IqKA1kQnBg', // 49€/mois
    yearly: 'price_1QfIbWHK89bZG7Iq7uuyiVsO'   // 490€/an
  },
  enterprise: {
    monthly: 'price_1QfBoLHK89bZG7IqkU21CHwh', // 99€/mois
    yearly: 'price_1QfIgkHK89bZG7IqwhVkLAqV'   // 990€/an
  }
} as const;